<template>
  <div>
    <div id="container" style="width: 100%;height: 100%;"></div>
  </div>
</template>

<script>
  let map;
  export default {
    name: "Map",
    props: ["address", "areaId"],
    data() {
      return {
        area: ""
      }
    },
    mounted() {
      let _this = this;
      _this.area = this.$utils.getAreaFullName(this.areaId)
      map = new BMap.Map('container');
      //map.centerAndZoom(new BMap.Point(116.331398,39.897445), 12);
      map.enableScrollWheelZoom(true);
      var myGeo = new BMap.Geocoder();
      // map.removeControl(new BMap.ScaleControl(opts));
      // 将地址解析结果显示在地图上，并调整地图视野
      myGeo.getPoint(_this.address, function(point) {
        if (point) {
          map.centerAndZoom(point, 14);
          map.addOverlay(new BMap.Marker(point, {
            title: _this.address
          }))
        } else {
          console.log('您选择的地址没有解析到结果！');
        }
      }, _this.area)
    },
    created() {
    }
  }
</script>

<style>
  .BMap_cpyCtrl {

    display: none;

  }

  .anchorBL {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/map.vue